import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { UserApiService } from 'features/users/api/user-api.service';
import { queryClient } from 'providers';

import { userQueryKeys } from './query-keys';
const { updateStatus } = UserApiService();

export const useStatusChange = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: any) => {
      return updateStatus(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: userQueryKeys.all,
        });
      },
    },
  );
};
